import { useEffect, useLayoutEffect, useState } from 'react';

export function useLockBodyScroll(_lock: boolean) {
    const [originalStyle, setOoriginalStyle] = useState('');

    useLayoutEffect(() => {
        setOoriginalStyle(window.getComputedStyle(document.body).overflow);
    }, []);

    useEffect(() => {
        if (_lock) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = originalStyle;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [_lock]);
}
